import type { ReactNode } from 'react';

export const symbol_account_child: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M637-849q73 31 127 85t85 127q31 73 31 157t-31 157q-31 73-85 127t-127 85q-73 31-157 31t-157-31q-73-31-127-85t-85-127q-31-73-31-157t31-157q31-73 85-127t127-85q73-31 157-31t157 31Zm84 610q99-99 99-241t-99-241q-99-99-241-99t-241 99q-99 99-99 241t99 241q99 99 241 99t241-99ZM394-686q0 38 24 62t62 24q38 0 62-24t24-62q0-38-24-62t-62-24q-38 0-62 24t-24 62Zm-50.5 149.5Q280-513 280-450v159q0 63 63.5 85.5T480-183q17 0 28-11t11-28q0-17-11-28t-28-11q-24-2-47-7.5T388-284q-8-4-12-11t0-15q15-26 44.5-32.5T480-349q38 0 73.5 6.5T589-303v64q0 11 7 18.5t18 7.5q29 0 47.5-23.5T680-291v-159q0-63-63.5-86.5T480-560q-73 0-136.5 23.5ZM440-387q-16-16-16-40t16-40q16-16 40-16t40 16q16 16 16 40t-16 40q-16 16-40 16t-40-16Zm40-96Z"
		/>
	</svg>
);
